import { Pipe, PipeTransform } from '@angular/core';
import { WorkspaceService } from 'src/app/shared/services/workspace.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
@Pipe({ name: 'workspaceName' })
export class WorkspaceNamePipe implements PipeTransform {
  constructor(private workspaceService: WorkspaceService) {}
  transform(workspaceId: string): Observable<string> {
    return this.workspaceService.currentWorkspaces.pipe(
      map((result) => {
        if (result) {
          let name = result.workspaces.find((x) => x.id == workspaceId)?.name;
          if (name && workspaceId == null) {
            name = name + ' (ORG)';
          }
          return name;
        }
      })
    );
  }
}
